import React, { useEffect, useState } from "react";
import { Navbar, Nav, Container, Button, NavDropdown } from "react-bootstrap";
import { useNavigate, useLocation, useParams } from "react-router-dom";
import Swal from "sweetalert2";
import "bootstrap/dist/css/bootstrap.min.css";
import "./JobSeekerNavbar.css";
import Logo from '../Images/GudnetNewLogo.webp';
import BaseUrl from '../../ApiServices/BaseUrl';

const EmployerNavbar = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [jobs, setJobs] = useState([]);
  const { id } = useParams();
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [userName, setUserName] = useState("");
  const [error, setError] = useState(null);
  const [userId, setUserId] = useState("");
  const [unreadMessageCount, setUnreadMessageCount] = useState(0);

  useEffect(() => {
    const user = JSON.parse(localStorage.getItem("user"));
    if (user) {
      setIsLoggedIn(true);
      setUserName(user.first_name || "Profile");
      setUserId(user.id || "");
    }
  }, []);

  useEffect(() => {
    const fetchJobData = async () => {
      try {
        if (!userId) return;

        const response = await fetch(`${BaseUrl}/api/employer/by-user?user_id=${userId}`);
        if (!response.ok) {
          throw new Error('Failed to fetch job data');
        }

        const data = await response.json();
        setJobs(data);
        console.log("Jobs=", data)
      } catch (err) {
        setError(err.message);
      }
    };

    fetchJobData();
  }, [userId]);

  useEffect(() => {
    if (!userId) return;

    let isMounted = true;
    const fetchUnreadCount = async () => {
      try {
        const response = await fetch(`${BaseUrl}/message/unread-count/employer/${userId}`);
        if (!response.ok) return;
        const data = await response.json();
        if (isMounted) {
          setUnreadMessageCount(Number(data?.unread_count || 0));
        }
      } catch (err) {
        console.error("Failed to fetch employer unread message count:", err);
      }
    };

    fetchUnreadCount();
    const interval = setInterval(fetchUnreadCount, 10000);
    return () => {
      isMounted = false;
      clearInterval(interval);
    };
  }, [userId]);

  const handleLogout = () => {
    Swal.fire({
      title: "Are you sure?",
      text: "You will be logged out of the system.",
      icon: "question",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, log me out!",
    }).then((result) => {
      if (result.isConfirmed) {
        localStorage.removeItem("user");
        localStorage.removeItem("userId");
        localStorage.removeItem("userPlan");
        localStorage.removeItem("userStartDate");
        localStorage.removeItem("userEnddate");
        setIsLoggedIn(false);
        navigate("/");
        Swal.fire("Logged Out!", "You have been successfully logged out.", "success");
      }
    });
  };

  const handleDashboard = () => navigate("/employer-dashboard");
  const handleProfile = () => navigate("/myprofile");
  const handlePostJob = () => navigate("/viewjobposting");
  const handleCandidates = () => navigate("/candidates");
  const handleAppliedCandidates = () => navigate("/appliedcandidates");
  const handlesubscription = () => navigate("/subscriptionplans");
  const handleSendAlert = () => navigate("/employer-send-alert");
  const handleEmpNurse = () => navigate("/emp-nurse");
  const handleEmpDoctor = () => navigate("/emp-doctor");
  const handleEmpDomestic = () => navigate("/emp-domestic");
  const handleEmpCompanyWorker = () => navigate("/candidates?category=company-worker");
  const isActive = (path) => location.pathname === path;
  const isHealthcareActive = ["/emp-nurse", "/emp-doctor"].includes(location.pathname);
  const isCompanyWorkerRoute =
    location.pathname === "/candidates" &&
    new URLSearchParams(location.search).get("category") === "company-worker";
  const isCandidatesRoute = location.pathname === "/candidates" && !isCompanyWorkerRoute;

  return (
    <Navbar expand="xl" bg="white" variant="light" fixed="top" className="shadow-sm py-2 custom-navbar">
      <Container fluid className="px-4"> {/* Changed to fluid and added padding */}
        {/* Logo at left end */}
        <Navbar.Brand
          className="d-flex align-items-center me-auto"
          style={{ cursor: "pointer" }}
          onClick={handleDashboard}
        >
          <img
            src={Logo}
            alt="Gudnet Logo"
            style={{ height: '50px', objectFit: 'contain' }}
          />
        </Navbar.Brand>

        <Navbar.Toggle aria-controls="main-navbar" />
        <Navbar.Collapse id="main-navbar">
          {/* Navigation links centered */}
          <Nav className="mx-auto nav-links compact-nav"> {/* Added compact-nav class */}
            <Nav.Link
              href="#"
              className={`nav-link-compact ${isActive("/employer-dashboard") ? "active-nav" : "nav-link-custom"}`}
              onClick={handleDashboard}
            >
              DASHBOARD
            </Nav.Link>
            <Nav.Link
              href="/viewjobposting"
              className={`nav-link-compact ${isActive("/viewjobposting") ? "active-nav" : "nav-link-custom"}`}
              onClick={handlePostJob}
            >
              JOBS
            </Nav.Link>

            {/* <Nav.Link
              href="/emp-domestic"
              className={`nav-link-compact ${isActive("/emp-domestic") ? "active-nav" : "nav-link-custom"}`}
              onClick={handleEmpDomestic}
            >
              DOMESTIC HELPERS
            </Nav.Link> */}

            <Nav.Link
              href="/candidates"
              className={`nav-link-compact ${isCandidatesRoute ? "active-nav" : "nav-link-custom"}`}
              onClick={handleCandidates}
            >
              CANDIDATES
            </Nav.Link>

            {/* Optimized Nurse and Domestic Helper Links */}
            <NavDropdown
              title="HEALTHCARE"
              id="employer-healthcare-dropdown"
              className={`news-dropdown healthcare-dropdown nav-link-compact ${isHealthcareActive ? "active-nav" : "nav-link-custom"}`}
            >
              <NavDropdown.Item
                href="/emp-nurse"
                onClick={handleEmpNurse}
                className={isActive("/emp-nurse") ? "dropdown-active" : ""}
              >
                Nurse
              </NavDropdown.Item>
              <NavDropdown.Item
                href="/emp-doctor"
                onClick={handleEmpDoctor}
                className={isActive("/emp-doctor") ? "dropdown-active" : ""}
              >
                Doctor
              </NavDropdown.Item>
            </NavDropdown>


            <Nav.Link
              href="/appliedcandidates"
              className={`nav-link-compact ${isActive("/appliedcandidates") ? "active-nav" : "nav-link-custom"}`}
              onClick={handleAppliedCandidates}
            >
              APPLIED CANDIDATES
            </Nav.Link>
            <Nav.Link
              href="/candidates?category=company-worker"
              className={`nav-link-compact ${isCompanyWorkerRoute ? "active-nav" : "nav-link-custom"}`}
              onClick={handleEmpCompanyWorker}
            >
              COMPANY WORKER
            </Nav.Link>

            <Nav.Link
              href="/agencies"
              className={`nav-link-compact ${isActive("/agencies") ? "active-nav" : "nav-link-custom"}`}
              onClick={() => navigate("/agencies")}
            >
              AGENCY
            </Nav.Link>

            <Nav.Link
              href="/employer-messages"
              className={`nav-link-compact ${isActive("/employer-messages") ? "active-nav" : "nav-link-custom"}`}
              onClick={() => navigate("/employer-messages")}
            >
              <span className="messages-nav-link">
                MESSAGES
                {unreadMessageCount > 0 && (
                  <span className="messages-unread-badge">{unreadMessageCount}</span>
                )}
              </span>
            </Nav.Link>

            <Nav.Link
              href="/subscriptionplans"
              className={`nav-link-compact ${isActive("/subscriptionplans") ? "active-nav" : "nav-link-custom"}`}
              onClick={handlesubscription}
            >
              SUBSCRIPTION
            </Nav.Link>

            {/* <Button
              variant="outline-primary"
              className={`nav-link-compact subscription-btn ${isActive("/subscriptionplans") ? "active" : ""}`}
              onClick={handlesubscription}
            >
              SUBSCRIPTION
            </Button> */}


            {/* Updated Dropdown Menu with shorter title */}
            <NavDropdown
              title="CONTACT US"
              id="info-dropdown"
              className="news-dropdown"
            >
              <NavDropdown.Item href="/employee-aboutus">About Us</NavDropdown.Item>
              <NavDropdown.Item href="/employee-contactus">Contact Us</NavDropdown.Item>
              <NavDropdown.Item href="/employee-tips-news">Tips & News</NavDropdown.Item>
              <NavDropdown.Item href="/employee-training">Training</NavDropdown.Item>
              <NavDropdown.Item href="/employer-faqs">FAQs</NavDropdown.Item>
              <NavDropdown.Item href="/employee-terms-and-conditions">Terms & Conditions</NavDropdown.Item>
              <NavDropdown.Item href="/employee-privacy-policy">Privacy Policy</NavDropdown.Item>
              <NavDropdown.Item href="/employee-returns-refunds-cancellation">
                Returns, Refunds & Cancellation Policy
              </NavDropdown.Item>
              <NavDropdown.Item href="/employee-shipping-delivery-policy">
                Shipping & Delivery Policy
              </NavDropdown.Item>
            </NavDropdown>
          </Nav>

          {/* User profile at right end */}
          <div className="navbar-buttons d-flex flex-column gap-2">
            <NavDropdown
              title={
                <>
                  <i className="bi bi-person-circle me-1"></i> {userName}
                </>
              }
              id="profile-dropdown"
              className={`fw-semibold px-3 profile-dropdown ${isActive("/myprofile") ? "active-nav" : ""}`}
              align="end"
            >
              <NavDropdown.Item
                onClick={handleProfile}
                className={isActive("/myprofile") ? "active-dropdown-item" : ""}
              >
                My Account
              </NavDropdown.Item>

              <NavDropdown.Item
                onClick={handleSendAlert}
                className={isActive("/employer-send-alert") ? "active-dropdown-item" : ""}
              >
                Send Bulk Messages
              </NavDropdown.Item>

              <NavDropdown.Divider />

              <NavDropdown.Item
                onClick={handleLogout}
                className="d-flex align-items-center text-danger"
              >
                <i className="bi bi-box-arrow-right me-2"></i> Logout
              </NavDropdown.Item>
            </NavDropdown>
          </div>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default EmployerNavbar;
